import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, Clock } from "lucide-react";
import { formatINR } from "@/lib/site";

export const PackageCard = ({ pkg, tall = false }) => {
  const save = pkg.original_price && pkg.original_price > pkg.price ? pkg.original_price - pkg.price : 0;
  return (
    <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.3, ease: "easeOut" }} className="group" data-testid={`package-card-${pkg.slug}`}>
      <Link to={`/packages/${pkg.slug}`} className="block">
        <div className={`relative overflow-hidden rounded-2xl ${tall ? "aspect-[3/4]" : "aspect-[4/3]"}`}>
          <img src={pkg.image} alt={`${pkg.title} tour package`} loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-500" />
          {save > 0 && (
            <span className="absolute top-4 left-4 bg-sun text-bone text-xs font-bold px-3 py-1.5 rounded-full" data-testid={`save-badge-${pkg.slug}`}>
              Save {formatINR(save)}
            </span>
          )}
          <div className="absolute bottom-0 inset-x-0 p-5 bg-gradient-to-t from-ink/80 to-transparent">
            <div className="flex items-center gap-2 text-bone/80 text-xs mb-1">
              <Clock size={12} /> {pkg.duration_days}D / {pkg.nights}N
              <span className="mx-1">·</span>
              <Star size={12} className="fill-sun text-sun" /> {pkg.rating} ({pkg.reviews})
            </div>
            <div className="flex items-end justify-between gap-3">
              <h3 className="font-display text-bone text-xl font-bold leading-tight">{pkg.title}</h3>
              <div className="text-right shrink-0">
                {save > 0 && <p className="text-bone/50 text-xs line-through">{formatINR(pkg.original_price)}</p>}
                <p className="text-bone font-display font-black text-lg">{formatINR(pkg.price)}<span className="text-xs font-normal text-bone/60"> /person</span></p>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-3 flex flex-wrap gap-1.5">
          {(pkg.route || []).slice(0, 4).map((r) => (
            <span key={r} className="text-xs text-ink/60 bg-sand/70 px-2.5 py-1 rounded-full">{r}</span>
          ))}
        </div>
      </Link>
    </motion.div>
  );
};
